import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  margin-bottom: ${theme.spacing.lg};
`
